

















import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            loading: false,
            selectedItems: [],
            availableSyncRole: [
                { text: "-", value: "-" },
                { text: this.$t("common.master"), value: "master" },
                { text: this.$t("common.copyCapitol"), value: "slave" },
            ],
        };
    },
    watch: {
        selectedItems() {
            console.log(this.selectedItems);
            this.$emit("input", this.selectedItems);
        },
    },
});
